import { ARTICLE_LIST_INTERVAL } from "../../templates/share-market-blog/src/templates/article-list/articleList.constants";
import { CATEGORIES } from "../constants/calculators";
import { ALL_CATEGORY_DATA } from "../templates/article-list/articleList.constants";

export const getBlogPostUri = post => {
  return `/${
    post?.categories?.nodes[0]?.uri?.split("/")?.[2]
  }${post.uri}`;
};

export const getCategories = (data, selectedCategory) => {
  const categoriesData = data?.reduce(
    (categories, curr) => {
      if (!curr?.posts?.nodes?.length) return categories;
      return [
        {
          title: curr?.name,
          href: curr?.name,
          selected: curr?.name === selectedCategory,
        },
        ...categories,
      ];
    },
    []
  );

  return [
    {
      title: CATEGORIES.ALL,
      href: ALL_CATEGORY_DATA.name,
      selected: selectedCategory === CATEGORIES.ALL,
    },
    ...categoriesData,
  ];
};

export const getPostsSplits = posts => {
  return [
    posts?.slice(0, ARTICLE_LIST_INTERVAL),
    posts?.slice(
      ARTICLE_LIST_INTERVAL,
      ARTICLE_LIST_INTERVAL * 2
    ),
    posts?.slice(ARTICLE_LIST_INTERVAL * 2),
  ];
};

export const getArticlesListPagePosts = ({
  categoryId,
  allPosts,
  categoryPosts,
  currentPage,
  postsPerPage,
}) => {
  if (categoryId !== ALL_CATEGORY_DATA.id)
    return categoryPosts;
  const articlesListPerPage = allPosts?.reduce(
    (posts, item, index) => {
      const chunkIndex = Math.floor(index / postsPerPage);

      if (!posts[chunkIndex]) {
        posts[chunkIndex] = [];
      }

      posts[chunkIndex].push(item);

      return posts;
    },
    []
  );

  return articlesListPerPage[currentPage];
};

export const getBestOfCategoryPosts = (category, posts) => {
  return posts?.filter(
    post => post?.categories?.nodes?.[0]?.name === category
  );
};

export const showPagination = (posts, totalPages) =>
  posts?.length > ARTICLE_LIST_INTERVAL * 2 ||
  totalPages > 1;
